import React from 'react';
import useContext from '../../../../hooks/useContext';
import { ProductContext } from '../providers/ProductProvider';
import Option from './Option';
import Distance from '../../../../styled/Distance';

interface IvariantSelection {
  distance?: string;
}

const Configuration = ({ distance }: IvariantSelection) => {
  const { configurations, isActive } = useContext(ProductContext);

  if (!configurations?.length || !isActive) {
    return null;
  }

  return (
    <>
      {configurations
        .filter(({ items }) => items.length > 1)
        .map((config) => (
          <Option key={config.type} {...config} />
        ))}
      {distance && <Distance size={distance} />}
    </>
  );
};

export default Configuration;
